import type { SxProps, Theme as ExtendedTheme } from '@mui/material/styles';
import { themeVars } from '@mds/ui';

export const editorSx: SxProps<ExtendedTheme> = (theme: ExtendedTheme) => ({
    '&&& .dark-theme.fr-box.fr-basic a': {
        color: themeVars(theme).palette.link.default,
        textDecoration: 'none',
        '&:hover, &:focus': { textDecoration: 'none' },
        '& > u': { textDecoration: 'none' },
    },
    '&&& .dark-theme.fr-box.fr-basic p, &&& li': {
        fontSize: theme.typography.body1.fontSize,
    },
    '&&& .fr-img-caption .fr-img-wrap > span': theme.typography.caption,
    '&&& .fr-img-space-wrap': theme.typography.body1,
    '&&& .dark-theme.fr-box.fr-basic img': {
        borderRadius: theme.shape.borderRadius,
        height: 'auto',
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-wrapper': {
        backgroundColor: themeVars(theme).palette.background.default,
        borderLeft: '2px solid ' + themeVars(theme).palette.divider,
        borderRight: '2px solid ' + themeVars(theme).palette.divider,
        borderBottom: '2px solid ' + themeVars(theme).palette.divider,
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-toolbar': {
        backgroundColor: themeVars(theme).palette.background.paper,
        border: '2px solid ' + themeVars(theme).palette.divider,
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn i, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn svg, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn span':
        {
            color: themeVars(theme).palette.text.primary,
            fill: themeVars(theme).palette.text.primary,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn svg path': {
        fill: themeVars(theme).palette.text.primary,
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown::after, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown:hover::after, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown:focus::after, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-btn-hover::after, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-expanded::after':
        {
            borderTopColor: themeVars(theme).palette.text.primary,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-active::after, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-active:hover::after, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-active:focus::after':
        {
            borderTop: '0',
            borderBottom: `4px solid ${themeVars(theme).palette.text.primary}`,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn:hover, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn:focus':
        {
            backgroundColor: themeVars(theme).palette.action.hover,
            color: themeVars(theme).palette.text.primary,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-disabled, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-disabled i, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-disabled svg, &&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-disabled svg path':
        {
            color: themeVars(theme).palette.text.disabled,
            fill: themeVars(theme).palette.text.disabled,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-disabled::after':
        {
            borderTopColor: themeVars(theme).palette.text.disabled,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-command.fr-open': {
        backgroundColor: themeVars(theme).palette.action.selected,
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-more-toolbar': {
        backgroundColor: themeVars(theme).palette.background.paper,
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-second-toolbar, &&& .dark-theme.fr-box.fr-basic .second-toolbar':
        {
            backgroundColor: themeVars(theme).palette.background.default,
            borderRight: '2px solid ' + themeVars(theme).palette.divider,
            borderBottom: '2px solid ' + themeVars(theme).palette.divider,
            borderLeft: '2px solid ' + themeVars(theme).palette.divider,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-element': {
        fontFamily: '"Inter"',
        fontSize: theme.typography.body1.fontSize,
        color: themeVars(theme).palette.text.primary,
        maxWidth: 1000,
        margin: '0 auto',
        padding: theme.spacing(0, 4),
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-element p': {
        margin: `${theme.spacing(2)} 0`,
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-element table': {
        color: `${themeVars(theme).palette.text.primary} !important`,
        borderColor: `${themeVars(theme).palette.divider} !important`,
        borderCollapse: 'collapse',
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-element table.fr-table-align-left': {
        maxWidth: '100%',
        marginLeft: 0,
        marginRight: 'auto',
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-element table.fr-table-align-center': {
        maxWidth: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-element table.fr-table-align-right': {
        maxWidth: '100%',
        marginLeft: 'auto',
        marginRight: 0,
    },
    '&&& .dark-theme.fr-box.fr-basic .fr-element table th, &&& .dark-theme.fr-box.fr-basic .fr-element table td':
        {
            color: `${themeVars(theme).palette.text.primary} !important`,
            borderColor: `${themeVars(theme).palette.divider} !important`,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-element table th *, &&& .dark-theme.fr-box.fr-basic .fr-element table td *':
        {
            color: `${themeVars(theme).palette.text.primary} !important`,
            borderColor: `${themeVars(theme).palette.divider} !important`,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-element table thead th, &&& .dark-theme.fr-box.fr-basic .fr-element table tfoot th, &&& .dark-theme.fr-box.fr-basic .fr-element table tfoot td':
        {
            color: `${themeVars(theme).palette.text.primary} !important`,
            borderColor: `${themeVars(theme).palette.divider} !important`,
            backgroundColor: `${themeVars(theme).palette.background.paper} !important`,
        },
    '&&& .dark-theme.fr-box.fr-basic .fr-placeholder': {
        color: themeVars(theme).palette.text.secondary,
        marginTop: theme.spacing(2),
    },
    '&&& .dark-theme .fr-view hr': {
        border: 0,
        backgroundColor: themeVars(theme).palette.divider,
        height: 2,
        margin: theme.spacing(2, 0),
    },
    '&&& .promotional-content': {
        display: 'block',
        margin: `${theme.spacing(2)} 0`,
        pointerEvents: 'none',
    },
    '&&& .promotional-content > img': {
        display: 'block',
        width: '100%',
        height: 'auto',
        borderRadius: '8px',
        pointerEvents: 'none',
    },
    [theme.breakpoints.down('md')]: {
        '&&& .promotional-content': { display: 'none' },
    },
    '&&& .fr-more-toolbar': { bottom: -1 },
});
